module.exports = __webpack_public_path__ + "assets/img/ability34.23a3ff17.png";